import { FC } from 'react';

interface Props {
  size: number;
  type: 'bronze' | 'diamond' | 'gold' | 'new-user' | 'platinum' | 'silver';
}

const TierIcon: FC<Props> = ({ size, type }) => (
  <>
    <img className="pro-tier-icon" alt={`tier ${type}`} src={`/static/images/tiers/${type}.svg`} />
    <style>{`
    .pro-tier-icon {
      height: ${size}px;
      margin-right: 8px;
      width: ${size}px;
    }
    `}</style>
  </>
);

export default TierIcon;
export type { Props as TierIconProps };
